import React from 'react';
import { SvgProps } from 'models/Icon';

export default (props: SvgProps) => (
  <svg
    width="12"
    height="13"
    viewBox="0 0 12 13"
    fill="transparent"
    stroke="currentColor"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    <path d="M2.5 4.5H9.5M2.5 4.5C1.94772 4.5 1.5 4.05228 1.5 3.5C1.5 2.94772 1.94772 2.5 2.5 2.5H9.5C10.0523 2.5 10.5 2.94772 10.5 3.5C10.5 4.05228 10.0523 4.5 9.5 4.5M2.5 4.5L2.5 9.5C2.5 10.0523 2.94772 10.5 3.5 10.5H8.5C9.05228 10.5 9.5 10.0523 9.5 9.5V4.5M5 6.5H7" />
  </svg>
);
